module.exports = __webpack_public_path__ + "resource/img/plus_form.0f7d9634.svg";